import type { Alpha2Code } from 'i18n-iso-countries';

export type RegionCode = Alpha2Code;

// exlude JP and IN as they are in preview
// add AQ for testing
export const AddressValidationAvailableRegionCodes: RegionCode[] = [
  'AR',
  'AT',
  'AQ',
  'AU',
  'BE',
  'BG',
  'BR',
  'CA',
  'CH',
  'CL',
  'CO',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MX',
  'MY',
  'NL',
  'NO',
  'NZ',
  'PL',
  'PR',
  'PT',
  'SE',
  'SG',
  'SI',
  'SK',
  'US',
];
export const RequiredStructuredAddressRegionCodes: RegionCode[] = ['NZ', 'AU'];

// Countries where FrankieOne database lookup is unavailable — POA is the only verification path
export const unsupportedDatabaseRegionCodes = [
  'BG', // Bulgaria
  'CY', // Republic of Cyprus
  'CZ', // Czech Republic
  'EE', // Estonia
  'GR', // Greece
  'HR', // Croatia
  'HU', // Hungary
  'IE', // Ireland
  'IS', // Iceland
  'LI', // Liechtenstein
  'LT', // Lithuania
  'LU', // Luxembourg
  'LV', // Latvia
  'MT', // Malta
  'NO', // Norway
  'PL', // Poland
  'RO', // Romania
  'SI', // Slovenia
  'SK', // Slovakia
];

// Countries where FrankieOne database lookup is available but POA is still required (one_plus_poa recipe)
export const poaRequiredWithDatabaseRegionCodes = [
  'AT', // Austria
  'BE', // Belgium
  'DE', // Germany
  'DK', // Denmark
  'ES', // Spain
  'FI', // Finland
  'FR', // France
  'GB', // United Kingdom
  'IT', // Italy
  'NL', // Netherlands
  'PT', // Portugal
  'SE', // Sweden
];
